@if (hasGeolocation) {
  <div class="geolocation-buttons map-control-button-container">
    <button mat-flat-button
      class="toggle-button map-control-button"
      [tmTooltip]="getTooltip()"
      [class.toggle-button--active]="isWatching()"
      (click)="onClick()">
      @if (!hasFix()) {
        <mat-icon svgIcon="location_searching"></mat-icon>
      } @else {
        <mat-icon svgIcon="{{ isFollowing() ? 'location_following' : 'my_location' }}"></mat-icon>
      }
    </button>
  </div>
}
